<template>
  <div>
    <div class="secondary">
      <v-container class="py-0">
        <v-sheet
          height="48px"
          color="transparent"
          class="d-flex align-center justify-space-between"
        >
          <div>
            <v-btn
              v-for="({ text, to }, i) in menu"
              :key="i"
              :to="to"
              color="white"
              class="font-weight-medium grey--text text--lighten-2"
              height="50px"
              tile
              text
            >
              <span class="text-caption">
                {{ text }}
              </span>
            </v-btn>
          </div>
          <div class="d-flex align-center">
            <div class="d-flex header-desktop-social">
              <Tooltip
                v-for="({ title, link, icon }, i) in social"
                :key="i"
                :tip="title"
                bottom
              >
                <v-btn :href="link" target="_blank" color="white" icon>
                  <v-icon x-small>{{ icon }}</v-icon>
                </v-btn>
              </Tooltip>
            </div>
            <v-divider class="grey ml-1 mr-3 my-1" vertical></v-divider>
            <span
              class="
                font-weight-medium
                white--text
                text-uppercase text-caption
                grey--text
                text--lighten-2
              "
            >
              {{ time }}
            </span>
          </div>
        </v-sheet>
      </v-container>
    </div>
    <v-container class="mx-auto py-0 my-7">
      <div class="d-flex justify-space-between align-center">
        <router-link to="/">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            class="header-logo"
          />
        </router-link>
        <Banner class="ml-8" type="top" />
      </div>
    </v-container>
    <v-container class="py-0">
      <v-sheet class="d-flex justify-center" color="primary" height="70px">
        <v-slide-group :show-arrows="md" center-active>
          <v-slide-item v-for="({ text, to }, i) in categories" :key="i">
            <v-btn
              :to="to"
              class="
                text-uppercase text-body-2
                font-weight-medium
                white--text
                px-5
              "
              height="70px"
              tile
              depressed
              text
            >
              {{ text }}
            </v-btn>
          </v-slide-item>
        </v-slide-group>
        <v-spacer></v-spacer>

        <v-menu
          v-model="menuSearch"
          content-class="menu-search-destkop"
          :close-on-content-click="false"
          min-width="500px"
          left
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              color="primary darken-1"
              class="font-weight-medium white--text"
              height="70px"
              width="70px"
              tile
              depressed
            >
              <v-icon
                color="white"
                v-text="menuSearch ? 'fas fa-times' : 'fas fa-search'"
                small
              ></v-icon>
            </v-btn>
          </template>
          <Search @search="menuSearch = false" />
        </v-menu>
      </v-sheet>
    </v-container>
  </div>
</template>

<script>
import Tooltip from "../../tools/Tooltip.vue";
import Search from "@/components/widgets/Search.vue";
import Banner from "@/components/cards/Banner.vue";
import { getSocial } from "@/config.js";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
    categories: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    time: "",
    menuSearch: false,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this);
    },
    md() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
  },
  mounted() {
    const dateTimeFormat = new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      weekday: "long",
    });

    let data = new Date();

    if (this.$route.query["data-atual"]) {
      data = new Date(this.$route.query["data-atual"]);

      data.setDate(data.getDate() + 1);
    }

    this.time = dateTimeFormat.format(data);
  },
  components: {
    Tooltip,
    Search,
    Banner,
  },
};
</script>

<style>
.header-logo {
  max-width: 196px;
}

.header-desktop-social {
  gap: 16px;
}
.menu-search-destkop {
  border-radius: 0 !important;
  padding: 20px 20px 14px 20px;
  background-color: white;
}

.menu-search-destkop .v-text-field * {
  max-height: 55px !important;
}
</style>
